import React from "react";
import schemaDashboard from "./schemaDashboard.json";
import BaseListPage from "../../../base/BaseListPage";
import withRouter from "../../../withRouter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import NavBar2 from "../../../components/NavBar2";
import DateRange from "../../../components/DateRange";
import InputFactory from "../../../components/InputFactory";
import DashboardAgentPresenter from "./DashboardAgentPresenter";
import Count from "../dashboard-admin/components/Count";

class DashboardAgentPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DashboardAgentPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      range: "",
      store: [],
      storess: "",
      agentForm: [],
    };
  }

  getCollectionName() {
    return "endorsement";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getValueForDashboardObject(object) {
    switch (object.label) {
      case "Pending":
        return this.presenter.calculatePendingInfo();
      case "New Endorsement":
        return this.presenter.calculateNewInfo();
      case "Disapproved":
        return this.presenter.calculateDisapprovedInfo();
      case "For QA":
        return this.presenter.calculateQAInfo();
      case "Done":
        return this.presenter.calculateDoneInfo();
      default:
        return { value: 0, percentage: 0 };
    }
  }

  handleCountClick(nav) {
    this.navigateTo(nav);
  }

  onChangeDate(where) {
    console.log("where date", where);
    this.presenter.onChangeDate(where);
  }

  filterSubmit(where) {
    this.presenter.filterSubmit(where);
  }

  onChangeFilter(type, value, field) {
    const where = {};
    switch (type) {
      case "Pointer":
        if (Object.keys(value).length > 0) {
          where[field] = { id: value.id };
        }
        break;
      case "Boolean":
        where[field] = value;
        break;
      default:
        where[field] = { $regex: value, $options: "i" };
    }
    this.filterSubmit(where);
  }

  render() {
    const objects = this.state.objects;
    const agentForms = this.state.agentForm;
    console.log("agentforms", agentForms);
    const schema = this.getSchema(this.getCollectionName());

    console.log("translate", schema);

    // Calculate counts
    const counts = agentForms.reduce(
      (acc, obj) => {
        const { rType } = obj;
        if (rType === "BUSINESS VERIFICATION (BVR)") {
          acc.BVR += 1;
        } else if (rType === "EMPLOYMENT VERIFICATION (EVR)") {
          acc.EVR += 1;
        } else if (rType === "RESIDENCE VERIFICATION (RVR)") {
          acc.RVR += 1;
        }
        return acc;
      },
      { BVR: 0, EVR: 0, RVR: 0 }
    );

    return (
      <>
        <NavBar2 />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <h1 className="fw-bold mt-3 text-capitalize">Home</h1>
            </div>
            <div className="row">
              <div className="col-sm-4 mb-2">
                <DateRange
                  onChange={this.onChangeDate.bind(this)}
                  field="createdAt"
                />
              </div>
            </div>
            <div className="card text-center mt-3 p-3">
              <div className="row">
                <div className="col ">
                  <h5>Report</h5>
                  <h6 className="fw-bold">BVR</h6>
                  <h6 className="fw-bold">EVR</h6>
                  <h6 className="fw-bold">RVR</h6>
                </div>
                <div className="col">
                  <h5>Count</h5>
                  <h6 className="fw-bold">{counts.BVR}</h6>
                  <h6 className="fw-bold">{counts.EVR}</h6>
                  <h6 className="fw-bold">{counts.RVR}</h6>
                </div>
                <div className="col">
                  <h5>Points</h5>
                  <h6 className="fw-bold">{counts.BVR}</h6>
                  <h6 className="fw-bold">{counts.EVR}</h6>
                  <h6 className="fw-bold">{counts.RVR}</h6>
                </div>
              </div>
            </div>

            <div className="row mt-1 g-3">
              {schemaDashboard.map((object, index) => {
                const { value, percentage } = this.getValueForDashboardObject(
                  object,
                  objects
                );

                const navigationTarget = object.navigationTarget;
                return (
                  <div key={index} className="col-6 col-md-3">
                    <Count
                      collection={object.collection}
                      icon={object.icon}
                      where={object.where}
                      val={value}
                      label={object.label}
                      labelAction={object.labelAction}
                      barangayValue={this.state.barangayValue}
                      object={object}
                      percentage={percentage}
                      bg={object.bg}
                      onClick={() => this.handleCountClick(navigationTarget)}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(DashboardAgentPage);
